import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { transformIntoArrayOptions } from "Helpers/Format";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import SponsorForm from "../SponsorForm";
import * as S from "./styles";

const SponsorDetails = ({ projectId }) => {
  const { api } = UseServices();
  const { loading } = UseGlobalLoading();

  const [sponsors, setSponsors] = useState([]);
  const [selectedSponsor, setSelectedSponsor] = useState(null);

  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    if (projectId) {
      getProjectStatuses();
      return getProjectSponsors(projectId);
    }

    // eslint-disable-next-line
  }, [projectId]);

  const getProjectSponsors = (project_id) => {
    api
      .post("/projects/get-project-sponsors", {
        project_id: project_id,
      })
      .then((response) => {
        const sponsors = response.data;

        setSponsors(sponsors);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const getProjectStatuses = () => {
    api
      .get("/projects/get-project-sponsor-statuses")
      .then((response) => {
        const statuses = response.data;

        setStatusOptions(
          transformIntoArrayOptions(statuses, "id", "display_name"),
        );
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      {selectedSponsor ? (
        <SponsorForm
          projectId={projectId}
          selectedSponsor={selectedSponsor}
          setSelectedSponsor={setSelectedSponsor}
          getProjectSponsors={getProjectSponsors}
          statusOptions={statusOptions}
        />
      ) : null}
      <Form>
        <S.Section>
          <span>Patrocinadores do Projeto</span>
          <hr />
        </S.Section>

        {!sponsors.length ? <span>Nenhum patrocinador cadastrado.</span> : null}

        {sponsors.map((sponsor) => (
          <S.Counterpart key={sponsor.id} id="sponsor">
            <S.CounterpartInfos>
              <h2>
                {sponsor.sponsor?.full_name ||
                  sponsor.select_project?.sponsor?.name ||
                  "—"}
              </h2>
              {sponsor.select_project ? (
                <span>
                  Seletiva:{" "}
                  <strong>
                    {sponsor.select_project.sponsor?.name
                      ? `${sponsor.select_project.sponsor.name} - `
                      : ""}
                    {sponsor.select_project.name}
                  </strong>
                </span>
              ) : null}
              <span>
                Status: <strong>{sponsor.status?.display_name}</strong>
              </span>
              <span>
                Possui Interesse:{" "}
                <strong>
                  {sponsor.has_interest === true
                    ? "Sim"
                    : sponsor.has_interest === false
                      ? "Não"
                      : "Não respondeu"}
                </strong>
              </span>

              <S.Buttons>
                <Button
                  type="button"
                  text="Ver detalhes"
                  disabled={loading}
                  onClick={() => setSelectedSponsor(sponsor)}
                />
              </S.Buttons>
            </S.CounterpartInfos>
          </S.Counterpart>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default SponsorDetails;
